export const ImportModalConst = {
    buttons: {
        ok: "OK",
        cancel: "Cancel",
        upload: "Upload"
    },
    title: "Import File",
    labels: {
        import_excel: "Import Data Using Excel Sheet(Format- xls,xlsx).",
        upload_file: "Upload File",
        download_excel: "Download Excel Template from",
        here: "Here",
    }
}